import React, { useEffect, useState } from "react";
import { UseAPICaller } from "../../apiCaller";

import "../../css/AppDialog.css";

interface Question {
    id:number;
    text:string;
    type:string;
    scale:number;
}

export interface AppDialogProps {
  isOpen: boolean;
  onDialogClose?: () => void;
}


const CreateSurveyDialogContent : React.FC<AppDialogProps> = ({isOpen, onDialogClose}) => {

    const {GetSurvey, UpdateSurvey, DeleteResource, PublishSurvey} = UseAPICaller();
    
    const [title, setTitle] = useState("");
    const [questions, setQuestions] = useState<Question[]>([]);
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (!isOpen) return;

        const GetSurveyData = async () =>{
            const surveyId = +sessionStorage.getItem("surveyId");
            if (surveyId) 
            {
                const data = await GetSurvey(surveyId);
                setTitle(data.title);
                setQuestions(data.questions);
            }
        }
        GetSurveyData();
        
    }, [isOpen]);

    const addQuestion = () => {
        setQuestions([...questions, {id:Date.now(), text:"", type:"rating", scale:5}]);
    }
    const removeQuestion = (id:number) => {
        setQuestions(questions.filter(q => q.id !== id));
    };

    const onPublish = () => {
        if (window.confirm("Are you sure that you want to publish this survey?")) {
            const surveyId = +sessionStorage.getItem("surveyId");
            if (surveyId) 
            {
                PublishSurvey(surveyId);
                if(onDialogClose)
                    onDialogClose();
            }
        }
    }

    const handleQuestionChange = (id:number, text:string) => {
        setQuestions(questions.map(q => q.id === id ? {...q, text} : q));
    }

    const OnSave = () => {
        const surveyId = +sessionStorage.getItem("surveyId");
        if (surveyId) 
        {
            UpdateSurvey(surveyId, {title, questions});
        }
    };

    const OnDelete = async () => {
        if (window.confirm("Are you sure that you want to delete this survey? \nThis is not reversable.")) {
            const surveyId = +sessionStorage.getItem("surveyId");
            if (surveyId) 
            {
                if (await DeleteResource("surveys", surveyId))
                {
                    if(onDialogClose)
                        onDialogClose();
                }
            }
        }
    };


    return (
        <div className="dialog-body">
            <div className="dialog-column-left">
                <div style={{display:"flex", flexDirection:"column", gap:6}}>
                    <button className="dialog-button save-button" onClick={OnSave} style={{borderStyle:"solid"}}>Save</button>
                    <button className={`dialog-button ${showInfo ? "inactive-button" : "blue-button"}`} onClick={addQuestion}>Add Question</button>
                    <button className="dialog-button blue-button" onClick={() => setShowInfo(!showInfo)}>{showInfo ? "Back" : "Show Info"}</button>
                </div>
                <div style={{marginTop:"auto", display:"flex", flexDirection:"column", gap:6}}>
                    <button className={`dialog-button ${(showInfo || questions.length === 0) ? "inactive-button" : "blue-button"}`} onClick={onPublish}>Publish</button>
                    <button className="dialog-button red-button" onClick={OnDelete}>Delete</button>
                </div>
            </div>
            {showInfo ? 
            (<div style={{paddingLeft:8, width:"100%", display:"flex", flexDirection:"column", gap:8}}>
                <h2>Survey Information</h2>
                <span>Each question is a rating question from 1 to 5, arranged like below.</span>
                <div style={{
                    width:"75%", 
                    display:"grid", 
                    gridTemplateColumns:"1fr 1fr 0.15fr 0.15fr 0.15fr 0.15fr 0.15fr 1.2fr", 
                    fontSize:"large", 
                    fontWeight:"bold", 
                    gap:8, 
                    paddingTop:16, 
                    paddingBottom:16, 
                    color:"#000F9F",
                    borderStyle:"solid",
                    borderWidth:"1px",
                    borderRadius:"8px",
                    borderColor:"black"
                }}>
                    <span style={{paddingLeft:6}}>Question title</span>
                    <span>Strongly disagree</span>
                    <span>1</span>
                    <span>2</span>
                    <span>3</span>
                    <span>4</span>
                    <span>5</span>
                    <span>Strongly agree</span>
                </div>
                <span>You can create new questions by pressing the button in the column to the left.</span>
                <span>You can remove questions by pressing the <i className="fa fa-times-circle" aria-hidden="true" style={{color:"#f00000"}}> </i> icon to the right of the question.</span>
                <h3>Suggestions for questions related to social impact</h3>
                <span>- To what extent did the event contribute to positive outcomes for society?</span>
                <span>- How much did the event inspire positive change in the community?</span>
                <span>- To what degree did the event increase your understanding of important societal issues?</span>
                <span>- How motivated did the event make you to engage in societal or community activities?</span>
                <span>- To what extent do you think the topics discussed at the event can have a positive impact on society?</span>
                <span>- How relevant did you find the content of the event to societal needs or challenges?</span>
                <span>- To what degree did the event create concrete opportunities for contributing to society?</span>
                <span>- How much did the event influence your own thoughts or behaviors towards societal benefit?</span>
            </div>) 
            :
            (<div  style={{width:"70%"}}>
                <div style={{display:"flex", flexDirection:"column", marginBottom:16}}>
                    <label style={{fontSize:"larger", fontWeight:"bold", paddingBottom:6}}>Title</label>
                    <input 
                        type="text" value={title} 
                        onChange={(e) => setTitle(e.target.value)} 
                        placeholder="Survey title"
                        style={{borderRadius: "6px", borderWidth: "1px", height:"50px", fontSize:"larger"}}
                    ></input>
                </div>
                <hr></hr>
                <div className="survey-edit-column">
                    {questions.map( q => (
                        <div className="survey-edit-row">
                            <input 
                                key={q.id}
                                value={q.text}
                                onChange={e => handleQuestionChange(q.id, e.target.value)}
                                placeholder="Question Text"
                            />
                            <i className="fa fa-times-circle survey-removeQuestion" aria-hidden="true" onClick={() => removeQuestion(q.id)}></i>
                        </div>
                    ))}
                </div>
            </div>)}
        </div>
        
    );
};

export default CreateSurveyDialogContent;